import { useEffect } from 'react';
import { cardServedEvent } from '../../../Utils/StoreHomePageUtils';
import { RelativeDiv, TestimonialHome } from './styled';
import { BannerSubTitle, BannerTitle } from '../BannersGrid/styled';
import AnywhereHorizontalScroll from '../../HelperComponents/AnywhereHorizontalScroll';
import TestimonialImage from '../TestimonialImage';
import { isWhiteColor } from '../../../Utils/helper';
import { images } from '../../../Constants/ImageUrls';

export default function Testimonials(props) {
  const { banner, isParentingPage, position } = props;
  useEffect(() => {
    cardServedEvent(banner, isParentingPage);
  }, []);

  return (
    // <LazyLoad height={446} once offset={100}>
    // </LazyLoad>
    <TestimonialHome
      sectionBgColorEnd={banner?.sectionBgColorEnd}
      sectionBgColorStart={banner?.sectionBgColorStart}
      padding={
        !isWhiteColor(banner?.sectionBgColorStart, banner?.sectionBgColorEnd)
      }
      isParentingPage={isParentingPage}
    >
      <BannerTitle subHeading={banner?.subHeading?.length}>
        <h2>{banner?.heading}</h2>
      </BannerTitle>
      {banner?.subHeading ? (
        <BannerSubTitle>
          <h2>{banner?.subHeading} </h2>
        </BannerSubTitle>
      ) : null}
      <RelativeDiv>
        <AnywhereHorizontalScroll
          firstElementId={`${banner?.itemName}first`}
          lastElementId={`${banner?.itemName}last`}
          leftArrow={<img src={images.arrowdownforward} alt="" />}
          rightArrow={<img src={images.arrowdownforward} alt="" />}
          scrolledWidth={420}
        >
          {banner?.items?.map((element, index) => {
            // {bannerDouble?.map((element, index) => {
            return (
              <TestimonialImage
                element={element}
                sectionName={banner?.itemName}
                index={index}
                // length={bannerDouble?.length}
                length={banner?.items?.length}
                key={index}
                banner={banner}
                position={position}
              />
            );
          })}
        </AnywhereHorizontalScroll>
      </RelativeDiv>
    </TestimonialHome>
  );
}
